'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var Select_module = require('./Select.module.scss.js');

var customStyles = {
    control: function (base, _a) {
        var isFocused = _a.isFocused, _b = _a.selectProps, touched = _b.touched, error = _b.error;
        var shouldDisplayError = touched && error;
        return _tslib.__assign(_tslib.__assign({}, base), { fontSize: Select_module["default"].fontSize, marginBottom: Select_module["default"].controlMarginBottom, borderRadius: Select_module["default"].borderRadius, boxShadow: 'none', border: shouldDisplayError && Select_module["default"].controlBorderError, '&:hover': {
                border: (shouldDisplayError && Select_module["default"].controlBorderError) || (!isFocused && Select_module["default"].controlBorder),
            } });
    },
    indicatorSeparator: function (base) { return (_tslib.__assign(_tslib.__assign({}, base), { display: 'none' })); },
    multiValueRemove: function (base) { return (_tslib.__assign(_tslib.__assign({}, base), { '&:hover': {
            backgroundColor: Select_module["default"].multiValueRemoveHoverBackground,
        } })); },
    option: function (base, _a) {
        var isDisabled = _a.isDisabled, isFocused = _a.isFocused, isSelected = _a.isSelected;
        var backgroundColor;
        var fontColor;
        if (isDisabled) {
            fontColor = Select_module["default"].optionDisabledFontColor;
        }
        else if (isSelected) {
            backgroundColor = Select_module["default"].optionSelectedBackground;
            fontColor = Select_module["default"].optionSelectedFontColor;
        }
        else if (isFocused) {
            backgroundColor = Select_module["default"].optionFocusedBackground;
        }
        return _tslib.__assign(_tslib.__assign({}, base), { backgroundColor: backgroundColor, color: fontColor });
    },
    menuPortal: function (base) { return (_tslib.__assign(_tslib.__assign({}, base), { zIndex: 9999 })); },
};

exports["default"] = customStyles;
//# sourceMappingURL=customStyles.js.map
